import {
  usePayPayAuthenticationUrl,
  usePayPayConnectUrl,
} from '~/features/reservationInput/lib/url'
import { usePayPayMessage } from '../../store/payment'

export function useContents() {
  const messageType = usePayPayMessage()
  const payPayConnectUrl = usePayPayConnectUrl()
  const payPayAuthenticationUrl = usePayPayAuthenticationUrl()
  return { messageType, payPayConnectUrl, payPayAuthenticationUrl }
}
